export enum Menu {
  HowToBorrow = '/how-to-borrow/',
  HowToRepay = '/how-to-repay/',
  FAQ = '/preguntas-frecuentes/',
  AboutUs = '/sobre-nosotros/',
  TermAndConditions = '/terminos-y-condiciones/',
  PolicyPrivacy = '/politica-de-privacidad/',
}
